import Phaser from 'phaser';
import { CST } from '../../../CST';
import { Score } from '../../../controller/score.js';

export default class Bricks extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.BRICKS);
	}

	preload() {
		// Bricks minigame assets — loaded here so they don't block the initial load
		this.load.image('bricks-intro', 'assets/Minigames/helping-gran-minigame/bricks-intro.png');
		this.load.image('bricks-outro', 'assets/Minigames/helping-gran-minigame/bricks-outro.png');
		this.load.image('ball', 'assets/Minigames/helping-gran-minigame/ball1.png');
		this.load.image('bricks-bg', 'assets/Minigames/helping-gran-minigame/bubble background.png');
		this.load.image('paddle', 'assets/Minigames/helping-gran-minigame/paddle1.png');
		this.load.image('brick', 'assets/Minigames/helping-gran-minigame/red1.png');
		this.load.audio('clock-sound', 'assets/Sounds/clock-sound.mp3');
		this.load.audio('wrong-sound', 'assets/Sounds/wrong-sound.mp3');
		this.load.audio('congratulations-sound', 'assets/Sounds/congratulations.mp3');
		this.load.audio('pop2-sound', 'assets/Sounds/pop2.mp3');
		// Variable declarations
		this.score = 0;
		this.brickIntro;
		this.brickOutro;
		this.playButton;
		this.bricks;
		this.paddle;
		this.ball;
		this.timer;
		this.timerText;
		this.breakText;
		this.breakBricks = 0;
		this.breakBricksText;
		this.breakPoints = 0;
		this.breakScoreEndGameText;
		this.breakBricksTextEndGame;
		this.endGameText;
		this.endGameButton;
		this.breakBlackBackground;
	}

	create() {
		this.clickSound = this.sound.add('click-sound', {
			volume: 0.5,
		});
		this.clock = this.sound.add('clock-sound');
		this.pop2 = this.sound.add('pop2-sound');
		this.congratulations = this.sound.add('congratulations-sound');
		this.wrong = this.sound.add('wrong-sound');
		this.score = new Score(this);
		const screenCenterX = this.cameras.main.worldView.x + this.cameras.main.width / 2;
		this.bubbleBackground = this.add.image(750, 400, 'bricks-bg').setScale(0.8);
		const fontStyle = {
			fontFamily: 'Calibri',
			fontSize: 48,
			color: '#ffffff',
			fontStyle: 'bold',
			padding: 16,
			shadow: {
				color: '#000000',
				fill: true,
				offsetX: 2,
				offsetY: 2,
				blur: 4,
			},
		};
		this.timerText = this.add.text(0, 0, '20:00', fontStyle);
		this.breakBricksText = this.add.text(1280, 0, 'Score: 0', fontStyle);
		//  Enable world bounds, but disable the floor
		this.physics.world.setBoundsCollision(true, true, true, false);
		//  Create the bricks in a 10x6 grid
		this.bricks = this.physics.add.staticGroup({
			key: 'brick',
			frameQuantity: 50,
			gridAlign: {
				width: 10,
				height: 6,
				cellWidth: 128,
				cellHeight: 64,
				x: 200,
				y: 185,
			},
		});
		this.ball = this.physics.add
			.image(screenCenterX, 600, 'ball')
			.setCollideWorldBounds(true)
			.setBounce(1);
		this.ball.setData('onPaddle', true);
		this.paddle = this.physics.add.image(750, 650, 'paddle').setImmovable();
		//  Our colliders
		this.physics.add.collider(this.ball, this.bricks, this.hitBrick, null, this);
		this.physics.add.collider(this.ball, this.paddle, this.hitPaddle, null, this);
		this.breakBlackBackground = this.add.image(750, 400, 'black-bg');
		this.breakBlackBackground.setAlpha(0.55);
		this.breakBlackBackground.setScale(8);
		this.brickIntro = this.add.image(750, 400, 'bricks-intro');
		this.playButton = this.add.image(750, 760, 'play-btn').setScale(0.5);
		this.playButton
			.setInteractive({
				useHandCursor: true,
			})
			.on(
				'pointerdown',
				function () {
					this.clickSound.play();
					destroySprite(this.brickIntro);
					destroySprite(this.playButton);
					destroySprite(this.breakBlackBackground);
					let canvas = this.sys.canvas;
					canvas.style.cursor = 'none';
					//  Input events
					this.input.on(
						'pointermove',
						function (pointer) {
							//  Keep the paddle within the game
							this.paddle.x = Phaser.Math.Clamp(pointer.x, 52, 1448);
							if (this.ball.getData('onPaddle')) {
								this.ball.x = this.paddle.x;
							}
						},
						this,
					);
					this.input.on(
						'pointerdown',
						function (pointer) {
							if (this.ball.getData('onPaddle')) {
								this.ball.setVelocity(-75, -300);
								this.ball.setData('onPaddle', false);
							}
						},
						this,
					);
					this.input.once('pointerdown', this.start, this);
				},
				this,
			);
	}

	start() {
		this.clock.play();
		this.timer = this.time.addEvent({
			delay: 20000,
			callback: this.gameOver,
			callbackScope: this,
		});
	}

	hitBrick(ball, brick) {
		this.pop2.play();
		this.score.addPoints();
		this.breakBricks = this.breakBricks + 1;
		this.breakPoints = this.breakPoints + 1;
		this.breakBricksText.setText('Score: ' + this.breakBricks);
		brick.disableBody(true, true);
		if (this.bricks.countActive() === 0) {
			this.resetLevel();
		}
	}

	resetBall() {
		this.wrong.play();
		this.ball.setVelocity(0);
		this.ball.setPosition(this.paddle.x, 600);
		this.ball.setData('onPaddle', true);
	}

	hitPaddle(ball, paddle) {
		var diff = 0;
		if (ball.x < paddle.x) {
			//  Ball is on the left-hand side of the paddle
			diff = paddle.x - ball.x;
			ball.setVelocityX(-10 * diff);
		} else if (ball.x > paddle.x) {
			//  Ball is on the right-hand side of the paddle
			diff = ball.x - paddle.x;
			ball.setVelocityX(10 * diff);
		} else {
			//  Ball is perfectly in the middle
			//  Add a little random X to stop it bouncing straight up!
			ball.setVelocityX(2 + Math.random() * 8);
		}
	}

	update() {
		if (this.ball.y > 700) {
			this.resetBall();
		}
		if (this.timer) {
			if (this.timer.getProgress() === 1) {
				this.clock.stop();
				this.timerText.setText('00:00');
			} else {
				const remaining = (20 - this.timer.getElapsedSeconds()).toPrecision(4);
				const pos = remaining.indexOf('.');
				let seconds = remaining.substring(0, pos);
				let ms = remaining.substr(pos + 1, 2);
				seconds = Phaser.Utils.String.Pad(seconds, 2, '0', 1);
				this.timerText.setText(seconds + ':' + ms);
			}
		}
	}

	gameOver() {
		this.congratulations.play();
		const screenCenterX = this.cameras.main.worldView.x + this.cameras.main.width / 2;

		const endGameTitle = {
			fontFamily: 'Calibri',
			fontSize: 48,
			color: '#ffffff',
			fontStyle: 'bold',
			padding: 16,
			shadow: {
				color: '#000000',
				fill: true,
				offsetX: 2,
				offsetY: 2,
				blur: 4,
			},
		};
		const endGameFontStyle = {
			fontFamily: 'Calibri',
			fontSize: 38,
			color: '#ffffff',
			padding: 16,
			shadow: {
				color: '#000000',
				fill: true,
				offsetX: 2,
				offsetY: 2,
				blur: 4,
			},
		};
		const clickFontStyle = {
			fontFamily: 'Calibri',
			fontSize: 20,
			color: '#ffffff',
			padding: 16,
			shadow: {
				color: '#000000',
				fill: true,
				offsetX: 2,
				offsetY: 2,
				blur: 4,
			},
		};
		let canvas = this.sys.canvas;
		canvas.style.cursor = 'default';
		this.paddle.destroy();
		this.ball.destroy();
		this.breakBlackBackground = this.add.image(750, 400, 'black-bg');
		this.breakBlackBackground.setAlpha(0.75);
		this.breakBlackBackground.setScale(8);
		this.endGameText = this.add.text(screenCenterX, 200, 'WELL DONE!', endGameTitle).setOrigin(0.5);
		this.breakBricksTextEndGame = this.add
			.text(screenCenterX, 350, 'You have earned ' + this.breakBricks + ' coins!', endGameFontStyle)
			.setOrigin(0.5);
		this.breakScoreEndGameText = this.add
			.text(screenCenterX, 400, 'So you get ' + this.breakPoints + ' points!', endGameFontStyle)
			.setOrigin(0.5);
		this.clickToContinue = this.add
			.text(screenCenterX, 600, 'Click to continue', clickFontStyle)
			.setOrigin(0.5);
		this.input.once(
			'pointerdown',
			() => {
				this.clickSound.play();
				this.endGameText.setVisible(false);
				this.breakBricksTextEndGame.setVisible(false);
				this.breakScoreEndGameText.setVisible(false);
				this.brickOutro = this.add.image(750, 400, 'bricks-outro');
				this.endGameButton = this.add.image(750, 740, 'next-btn').setScale(0.5);
				this.endGameButton
					.setInteractive({
						useHandCursor: true,
					})
					.on(
						'pointerdown',
						function () {
							this.clickSound.play();
							destroySprite(this.brickOutro);
							destroySprite(this.endGameButton);
							this.scene.sendToBack();
							this.scene.resume(CST.SCENES.STORY_SELECT, {
								story: 7,
							});
							this.scene.stop();
						},
						this,
					);
			},
			this,
		);
	}
}

function destroySprite(sprite) {
	sprite.destroy();
}
